import React from 'react';
import { CardMedia as MuiCardMedia } from '@mui/material';
import { styled } from '@mui/material/styles';

export const POST_CARD_HEIGHT = 200;
const POST_CARD_MEDIA_WIDTH = 300;
const POST_CARD_MEDIA_MOBILE_HEIGHT = 200;

const StyledCardMedia = styled(MuiCardMedia)(({ theme }: any) => ({
  margin: theme.spacing(2),
  width: `calc(${POST_CARD_MEDIA_WIDTH}px - ${theme.spacing(3)})`,
  minHeight: `calc(${POST_CARD_HEIGHT}px - ${theme.spacing(3)})`,
  flexShrink: 0,
  borderRadius: theme.shape.borderRadius * 2,
  [theme.breakpoints.up('xs')]: {
    marginRight: theme.spacing(1),
  },
  [theme.breakpoints.down('sm')]: {
    marginTop: theme.spacing(3),
    height: POST_CARD_MEDIA_MOBILE_HEIGHT,
    width: `calc(100% - ${theme.spacing(4)})`,
  },
  '& .MuiSkeleton-root': {
    minHeight: `calc(${POST_CARD_HEIGHT}px - ${theme.spacing(3)})`,
    [theme.breakpoints.down('sm')]: {
      width: `calc(100% - ${theme.spacing(3)})`,
    },
  },
}));

function CardMedia({ children, ...props }: any) {
  return <StyledCardMedia {...props}>{children}</StyledCardMedia>;
}

export default CardMedia;
